import { render, staticRenderFns } from "./FilePlusIcon.vue?vue&type=template&id=617d081f&"
import script from "./FilePlusIcon.vue?vue&type=script&lang=js&"
export * from "./FilePlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports